import { GlAlert, GlButton, GlIcon, GlLink, GlSprintf } from '@gitlab/ui';
import { uniqueId } from 'lodash-es';
import { s__, sprintf } from '~/locale';
import { embedStyle, getPlaceholderStyles } from '../markdown/external_content';
const ALERT_BORDER_RADIUS = 'var(--gl-border-radius-lg) var(--gl-border-radius-lg) 0 0';
export default {
    name: 'ExternalContent',
    i18n: {
        heading: s__('ExternalContent|External content from %{provider} (%{host})')
    },
    components: {
        GlAlert,
        GlButton,
        GlIcon,
        GlLink,
        GlSprintf
    },
    props: {
        provider: {
            type: Object,
            required: true
        },
        href: {
            type: String,
            required: false,
            default: null
        },
        width: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        height: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        }
    },
    emits: [
        'activated'
    ],
    data () {
        return {
            activated: false,
            headingId: uniqueId('external-content-heading-'),
            descriptionId: uniqueId('external-content-description-')
        };
    },
    computed: {
        active () {
            return this.activated || !this.provider.require_activation;
        },
        host () {
            return new URL(this.provider.src_origin).host;
        },
        title () {
            return sprintf(this.$options.i18n.heading, {
                provider: this.provider.name,
                host: this.host
            }, false);
        },
        placeholderStyles () {
            return getPlaceholderStyles(this.width, this.height);
        }
    },
    methods: {
        async activate () {
            this.activated = true;
            await this.$nextTick();
            this.$emit('activated');
        }
    },
    embedStyle,
    alertStyle: {
        '--gl-alert-border-radius': ALERT_BORDER_RADIUS
    }
};
